import React from 'react';
import styled from 'styled-components';
import { Spinner } from '@prezi/common-components';
import { white } from '@prezi/common-design';
import * as Atoms from '../../atoms';
import * as Molecules from '../../molecules';
import { EIGHT, HEADING_Z } from '../../const';
import { localI18n } from '../../../i18n';
const uxCopy = {
  header: localI18n._("Sharing and privacy")
};
const HeaderContainer = styled.div.withConfig({
  displayName: "Header__HeaderContainer",
  componentId: "sc-1vfyf1y-0"
})(["display:flex;position:sticky;top:0;background:", ";z-index:", ";padding-bottom:", "px;"], white, HEADING_Z, EIGHT);
export default (({
  isLoading,
  hasError,
  hasReducedPadding
}) => {
  return React.createElement(HeaderContainer, null, React.createElement(Atoms.Dumb.ModalHeader, {
    hasReducedPadding: hasReducedPadding
  }, uxCopy.header), isLoading && React.createElement(Atoms.Dumb.HeaderIconWrapper, null, React.createElement(Spinner, {
    size: "sm"
  })), hasError && React.createElement(Molecules.Dumb.ErrorStatus, null));
});